module.exports = __webpack_public_path__ + "img/xing.2a04c64a.png";